import { helpers } from "vuelidate/lib/validators"

const cyrillic = helpers.regex('cyrillic', /^[ а-яА-ЯёЁ-]*$/)
const checkDate = helpers.regex('date', /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/)
const snils = helpers.regex('snils', /^\d{3}-\d{3}-\d{3} \d{2}$/)
const setOfSymbols = helpers.regex('setOfSymbols', /^[ а-яА-ЯёЁA-Za-z0-9.,-:;№\_\(\)]*$/)
const cellularPhone = helpers.regex('cellularPhone', /^\+ \[0-9]{16}$/)
const meanScore = helpers.regex('meanScore', /^[3-5]{1}\.[0-9]{3}$/)

const daysRegex = helpers.regex('daysRegex', /^[0-9]$|^[1-9]\d$|^[1-2]\d{2}$|^3[0-5]\d$|^36[0-5]$/)
const hoursRegex = helpers.regex('hoursRegex', /^\d$|^1\d$|^2[0-3]$/)
const secondsMinutesRegex = helpers.regex('secondsMinutesRegex', /^\d$|^[1-5]\d$/)

const numberPhone = helpers.regex('numberPhone', /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/)


const checkSnilsSum = snils => {
  let sum = 0
  let checkDigit = 0

  if (!!snils) {
    snils = snils.replace(/-/g, '')
  } else {
    return true
  }

  for (let i = 0; i < 9; i++) {
    sum += parseInt(snils[i]) * (9 - i)
  }

  if (sum < 100) {
    checkDigit = sum
  } else if (sum > 101) {
    checkDigit = parseInt(sum % 101)
    if (checkDigit === 100) {
      checkDigit = 0
    }
  }

  return checkDigit === parseInt(snils.slice(-2))
}

const stopSymbols = string => {
  if (!string) return true
  return (!/["']/.test(string))
}

const egeScore = value => +value === 0 || (+value >= 40 && +value <= 100)
const ebeScore = value => +value === 0 || (+value >= 40 && +value <= 100)

const requiredObjectId = value => Boolean(value?.id)

const setValidateMessages = property => {
  const validations = property.$params
  const validationsKeys = Object.keys(validations)

  const errors = []
  if (property?.stopSymbols !== false && !property.$dirty) return errors

  validationsKeys.forEach(key => {
    switch (key) {
      case 'required':
        !property[key] && errors.push('Обязательное поле')
        break
      case 'maxLength':
        !property[key] && errors.push(`Не больше ${validations.maxLength?.max} символов`)
        break
      case 'maxValue':
        !property[key] && errors.push(`Значение не больше ${validations.maxValue?.max}`)
        break
      case 'dateFormat':
        !property[key] && errors.push('Дата указана некорректно')
        break
      case 'email':
        !property[key] && errors.push('E-mail невалидный')
        break
      case 'cyrillic':
        !property[key] && errors.push('Буквы кириллицы, пробел и дефис')
        break
      case 'stopSymbols':
        !property[key] && errors.push('Запрещённые символы')
        break
      case 'snilsFormat': case 'checkSnilsSum':
        !property[key] && errors.push('СНИЛС невалидный')
        break
      case 'checkMinAge':
        !property[key] && errors.push('Минимальный возраст обучения ДПО 18 лет')
        break
      case 'regexFrom0To999':
        !property[key] && errors.push('От 0 до 999')
        break
      case 'fileType':
        !property[key] && errors.push('Файл должен быть в формате PDF')
        break
      case 'fileSize':
        !property[key] && errors.push('Максимальный размер файла 3 Мб')
        break
      case 'filesLimit':
        !property[key] && errors.push(`Максимальное колличесво файлов ${validations.filesLimit?.max}`)
        break
      case 'numberPhone':
        !property[key] && errors.push('Некорректно указан номер телефона')
        break
    }
  })
  return errors
}

export {
  numberPhone,
  cyrillic,
  checkDate,
  snils,
  setOfSymbols,
  cellularPhone,
  meanScore,
  checkSnilsSum,
  egeScore,
  ebeScore,
  daysRegex,
  hoursRegex,
  secondsMinutesRegex,
  setValidateMessages,
  requiredObjectId
}
